import { render } from "./MyReferrals.vue?vue&type=template&id=391b66c5&scoped=true"
import script from "./MyReferrals.vue?vue&type=script&lang=js"
export * from "./MyReferrals.vue?vue&type=script&lang=js"

import "./MyReferrals.vue?vue&type=style&index=0&id=391b66c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391b66c5"]])

export default __exports__